import { Component, Host, h, Element } from '@stencil/core';

export interface AhaSidepanelItem extends HTMLAhaSidepanelItemElement {}

/**
 * A single item in the sidepanel pull tabs list.
 *
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-sidepanel-item',
  styleUrl: 'aha-sidepanel-item.css',
  shadow: true,
})
export class AhaSidepanelItem {
  @Element() host!: HTMLAhaSidepanelItemElement;
  render() {
    return (
      <Host role="button">
        <slot></slot>
      </Host>
    );
  }
}
